const fullEleFieldConfig = {
    // 全电普票
    1: {
        version: 1.8,
        queryForm: [
            {
                // 0
                label: '开票日期',
                selected: true,
                default: true,
                name: 'invoiceDate',
                type: 'date',
            },
            {
                label: '购方名称',
                selected: true,
                default: true,
                name: 'custName',
            },
            {
                label: '购方信用代码',
                selected: true,
                default: true,
                name: 'custCreditCode',
            },
            {
                label: '发票性质',
                selected: true,
                default: true,
                name: 'isRed',
                dict: 'is_red_all',
                type: 'dict',
            },
            {
                label: '下载标志',
                selected: true,
                default: true,
                name: 'isDownload',
                dict: 'is_download',
                type: 'dict',
            },
            {
                //5
                label: '开票人',
                selected: false,
                default: false,
                name: 'openPeople',
            },
            {
                label: '发票状态',
                selected: false,
                default: false,
                name: 'invoiceStatus',
                dict: 'invoice_status',
                type: 'dict',
            },
            {
                label: '单据编号',
                selected: true,
                default: true,
                name: 'billCode',
                type:'businessBase',
            },
            {
                label: '交付状态',
                selected: true,
                default: true,
                name: 'sendStatus',
                dict: 'send_status',
                type: 'dict',
            },
            {
                label: '全电发票号码',
                selected: false,
                default: false,
                name: 'electricInvoiceNum',
            },
            {
                //10
                label: '数据来源',
                selected: false,
                default: false,
                name: 'invoiceSource',
                dict: 'invoice_source',
                type: 'dict',
            },
            {
                label: '成品油',
                selected: false,
                default: false,
                name: 'invSubType',
                dict: 'yes_no_flag',
                type: 'dict',
            },
            {
                label: '业务单据号',
                selected: false,
                default: false,
                name: 'businessCode',
                type:'businessBase',
            },
            {
                label: '合同号',
                selected: false,
                default: false,
                name: 'contractCode',
                type:'businessBase',
            },
            {
                label: '项目名称',
                selected: false,
                default: false,
                name: 'projectName',
                type:'businessBase',
            },
            {
                //15
                label: '申请人',
                selected: false,
                default: false,
                name: 'applicant',
            },
            {
                label: '扩展1',
                selected: false,
                default: false,
                name: 'extendInfo1',
                type:'businessBase',
            },
            {
                label: '扩展2',
                selected: false,
                default: false,
                name: 'extendInfo2',
                type:'businessBase',
            },
            {
                label: '扩展3',
                selected: false,
                default: false,
                name: 'extendInfo3',
                type:'businessBase',
            },
            {
                label: '冲红原因',
                selected: false,
                default: false,
                name: 'redReason',
                dict: 'red_confirm_red_reason',
                type: 'dict',
            },
            {
                //20
                label: '红字确认单编号',
                selected: false,
                default: false,
                name: 'redInformNo',
            },
            {
                label: '原蓝票号码',
                selected: false,
                default: false,
                name: 'blueElectricInvoiceNum',
            },
            {
                label: '是否还原',
                selected: false,
                default: false,
                name: 'restoreStatus',
                dict: 'yes_no_flag',
                type: 'dict',
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
                name: 'specificElements',
                dict: 'specific_element',
                type: 'dict',
            },
            {
                label: '本地PDF状态',
                selected: false,
                default: false,
                name: 'localPdfStatus',
                dict: 'local_pdf_status',
                type: 'dict',
            },
            {
                label: '手机号码',
                selected: false,
                default: false,
                name: 'custMobile',
            },
            {
                label: '回调状态',
                selected: false,
                default: false,
                name: 'callBackStatus',
                dict: 'call_back_status',
                type: 'dict',
            },
            {
                label: '事业部',
                selected: false,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: false,
                default: false,
                name: 'regionName',
                type: 'regionNo',
            },
            {
                label: '管理城市',
                selected: false,
                default: false,
                name: 'cityName',
                type: 'managerCityNo',
            },
            {
                label: '主管税局省(市)',
                selected: false,
                default: false,
                name: 'province',
                type: 'taxBureauId',
            },
            {
                label: '机构名称',
                selected: false,
                default: false,
                name: 'selectedOrgs',
                type: 'selectedOrgs',
            },
        ],
        table: [
            {
                //0
                label: '单据编号',
                selected: true,
                default: true,
                name: 'billCode',
                sort: true,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
                name: 'invType',
                sort: true,
            },
            {
                label: '全电发票号码',
                selected: true,
                default: true,
                name: 'electricInvoiceNum',
                sort: true,
            },
            {
                label: '发票性质',
                selected: true,
                default: true,
                name: 'electricInvoiceNum',
                sort: true,
            },
            {
                label: '购方名称',
                selected: true,
                default: true,
                name: 'custName',
                sort: true,
            },
            {
                //5
                label: '购方信用代码',
                selected: true,
                default: true,
                name: 'custCreditCode',
                sort: true,
            },
            {
                label: '购方地址',
                selected: false,
                default: false,
                name: 'custAddress',
            },
            {
                label: '购方电话',
                selected: false,
                default: false,
                name: 'custPhone',
            },
            {
                label: '购方开户行',
                selected: false,
                default: false,
                name: 'custBank',
            },
            {
                label: '购方银行账号',
                selected: false,
                default: false,
                name: 'custBankAccount',
            },
            {
                //10
                label: '合计金额',
                selected: true,
                default: true,
                name: 'totalAmt',
            },
            {
                label: '合计税额',
                selected: true,
                default: true,
                name: 'totalTaxamt',
            },
            {
                label: '价税合计',
                selected: false,
                default: false,
                name: 'adValoremTotal',
            },
            {
                label: '含税折扣金额',
                selected: false,
                default: false,
                name: 'discountTaxAmt',
            },
            {
                label: '备注',
                selected: false,
                default: false,
                name: 'remark',
            },
            {
                //15
                label: '下载标志',
                selected: true,
                default: true,
                name: 'isDownload',
                dict: 'is_download',
            },
            {
                label: '发票状态',
                selected: true,
                default: true,
                name: 'invoiceStatus',
                dict: 'invoice_status',
            },
            {
                label: '开票人',
                selected: false,
                default: false,
                name: 'openPeople',
            },
            {
                label: '开票日期',
                selected: false,
                default: false,
                name: 'invoiceDate',
            },
            {
                label: '数据来源',
                selected: false,
                default: false,
                name: 'invoiceSource',
                dict: 'invoice_source',
            },
            {
                //20
                label: '关联销售单',
                selected: false,
                default: false,
                name: 'billNum',
            },
            {
                label: '主商品名称',
                selected: false,
                default: false,
                name: 'matName',
            },
            {
                label: '税率',
                selected: false,
                default: false,
                name: 'taxRate',
            },
            {
                label: '邮箱',
                selected: false,
                default: false,
                name: 'custEmail',
            },
            {
                label: '交付状态',
                selected: false,
                default: false,
                name: 'sendStatus',
                dict: 'send_status',
            },
            {
                //25
                label: '打印标识',
                selected: false,
                default: false,
                name: 'isPrint',
                dict: 'is_print',
            },
            {
                label: '发票ID',
                selected: false,
                default: false,
                name: 'invoiceId',
                sort: true,
            },
            {
                label: '成品油',
                selected: false,
                default: false,
                name: 'invSubType',
                dict: 'yes_no_flag',
            },
            {
                label: '业务单据号',
                selected: false,
                default: false,
                name: 'businessCode',
            },
            {
                //29
                label: '是否还原',
                selected: false,
                default: false,
                name: 'restoreStatus',
            },
            {
                //30
                label: '是否关联',
                selected: false,
                default: false,
                name: 'associations',
                dict: 'yes_no_flag',
            },
            {
                label: '冲红原因',
                selected: false,
                default: false,
                name: 'redReason',
                dict: 'red_confirm_red_reason',
            },
            {
                label: '红字确认单编号',
                selected: false,
                default: false,
                name: 'redInformNo',
            },
            {
                label: '原蓝票号码',
                selected: false,
                default: false,
                name: 'blueElectricInvoiceNum',
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
                name: 'blueElectricInvoiceNum',
            },
            {
                label: '本地PDF状态',
                selected: false,
                default: false,
                name: 'localPdfStatus',
            },
            {
                label: '手机号码',
                selected: false,
                default: false,
                name: 'custMobile',
            },
            {
                label: '回调状态',
                selected: false,
                default: false,
                name: 'callBackStatus',
            },
            {
                label: '税局附件下载状态',
                selected: false,
                default: false,
                name: 'isDownload',
            },
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
            },
            {
                label: '主管税局所在省（市）',
                selected: true,
                default: false,
                name: 'province',
            },
            {
                label: '销方名称',
                selected: true,
                default: true,
                name: 'saleName',
                sort: true,
            },
            {
                label: '销方信用代码',
                selected: true,
                default: true,
                name: 'saleCreditCode',
                sort: true,
            },
        ],
    },
    // 全电专票
    2: {
        version: 1.8,
        queryForm: [
            {
                // 0
                label: '开票日期',
                selected: true,
                default: true,
                name: 'invoiceDate',
                type: 'date',
            },
            {
                label: '购方名称',
                selected: true,
                default: true,
                name: 'custName',
            },
            {
                label: '购方信用代码',
                selected: true,
                default: true,
                name: 'custCreditCode',
            },
            {
                label: '发票性质',
                selected: true,
                default: true,
                name: 'isRed',
                dict: 'is_red_all',
                type: 'dict',
            },
            {
                label: '下载标志',
                selected: true,
                default: true,
                name: 'isDownload',
                dict: 'is_download',
                type: 'dict',
            },
            {
                //5
                label: '开票人',
                selected: false,
                default: false,
                name: 'openPeople',
            },
            {
                label: '发票状态',
                selected: false,
                default: false,
                name: 'invoiceStatus',
                dict: 'invoice_status',
                type: 'dict',
            },
            {
                label: '单据编号',
                selected: true,
                default: true,
                name: 'billCode',
                type:'businessBase',
            },
            {
                label: '交付状态',
                selected: true,
                default: true,
                name: 'sendStatus',
                dict: 'send_status',
                type: 'dict',
            },
            {
                label: '全电发票号码',
                selected: false,
                default: false,
                name: 'electricInvoiceNum',
            },
            {
                //10
                label: '数据来源',
                selected: false,
                default: false,
                name: 'invoiceSource',
                dict: 'invoice_source',
                type: 'dict',
            },
            {
                label: '成品油',
                selected: false,
                default: false,
                name: 'invSubType',
                dict: 'yes_no_flag',
                type: 'dict',
            },
            {
                label: '业务单据号',
                selected: false,
                default: false,
                name: 'businessCode',
                type:'businessBase',
            },
            {
                label: '合同号',
                selected: false,
                default: false,
                name: 'contractCode',
                type:'businessBase',
            },
            {
                label: '项目名称',
                selected: false,
                default: false,
                name: 'projectName',
                type:'businessBase',
            },
            {
                //15
                label: '申请人',
                selected: false,
                default: false,
                name: 'applicant',
            },
            {
                label: '扩展1',
                selected: false,
                default: false,
                name: 'extendInfo1',
                type:'businessBase',
            },
            {
                label: '扩展2',
                selected: false,
                default: false,
                name: 'extendInfo2',
                type:'businessBase',
            },
            {
                label: '扩展3',
                selected: false,
                default: false,
                name: 'extendInfo3',
                type:'businessBase',
            },
            {
                label: '冲红原因',
                selected: false,
                default: false,
                name: 'redReason',
                dict: 'red_confirm_red_reason',
                type: 'dict',
            },
            {
                //20
                label: '红字确认单编号',
                selected: false,
                default: false,
                name: 'redInformNo',
            },
            {
                label: '原蓝票号码',
                selected: false,
                default: false,
                name: 'blueElectricInvoiceNum',
            },
            {
                label: '是否还原',
                selected: false,
                default: false,
                name: 'restoreStatus',
                dict: 'yes_no_flag',
                type: 'dict',
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
                name: 'specificElements',
                dict: 'specific_element',
                type: 'dict',
            },
            {
                label: '本地PDF状态',
                selected: false,
                default: false,
                name: 'localPdfStatus',
                dict: 'local_pdf_status',
                type: 'dict',
            },
            {
                label: '手机号码',
                selected: false,
                default: false,
                name: 'custMobile',
            },
            {
                label: '回调状态',
                selected: false,
                default: false,
                name: 'callBackStatus',
                dict: 'call_back_status',
                type: 'dict',
            },
            {
                label: '事业部',
                selected: false,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: false,
                default: false,
                name: 'regionName',
                type: 'regionNo',
            },
            {
                label: '管理城市',
                selected: false,
                default: false,
                name: 'cityName',
                type: 'managerCityNo',
            },
            {
                label: '主管税局省(市)',
                selected: false,
                default: false,
                name: 'province',
                type: 'taxBureauId',
            },
            {
                label: '机构名称',
                selected: false,
                default: false,
                name: 'selectedOrgs',
                type: 'selectedOrgs',
            },
        ],
        table: [
            {
                //0
                label: '单据编号',
                selected: true,
                default: true,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
            },
            {
                label: '全电发票号码',
                selected: true,
                default: true,
            },
            {
                label: '发票性质',
                selected: true,
                default: true,
            },
            {
                label: '购方名称',
                selected: true,
                default: true,
            },
            {
                //5
                label: '购方信用代码',
                selected: true,
                default: true,
            },
            {
                label: '购方地址',
                selected: false,
                default: false,
            },
            {
                label: '购方电话',
                selected: false,
                default: false,
            },
            {
                label: '购方开户行',
                selected: false,
                default: false,
            },
            {
                label: '购方银行账号',
                selected: false,
                default: false,
            },
            {
                //10
                label: '合计金额',
                selected: true,
                default: true,
            },
            {
                label: '合计税额',
                selected: true,
                default: true,
            },
            {
                label: '价税合计',
                selected: false,
                default: false,
            },
            {
                label: '含税折扣金额',
                selected: false,
                default: false,
            },
            {
                label: '备注',
                selected: false,
                default: false,
            },
            {
                //15
                label: '下载标志',
                selected: true,
                default: true,
            },
            {
                label: '发票状态',
                selected: true,
                default: true,
            },
            {
                label: '开票人',
                selected: false,
                default: false,
            },
            {
                label: '开票日期',
                selected: false,
                default: false,
            },
            {
                label: '数据来源',
                selected: false,
                default: false,
            },
            {
                //20
                label: '关联销售单',
                selected: false,
                default: false,
            },
            {
                label: '主商品名称',
                selected: false,
                default: false,
            },
            {
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '邮箱',
                selected: false,
                default: false,
            },
            {
                label: '交付状态',
                selected: false,
                default: false,
            },
            {
                //25
                label: '打印标识',
                selected: false,
                default: false,
            },
            {
                label: '发票ID',
                selected: false,
                default: false,
            },
            {
                label: '成品油',
                selected: false,
                default: false,
            },
            {
                label: '业务单据号',
                selected: false,
                default: false,
            },
            {
                //29
                label: '是否还原',
                selected: false,
                default: false,
            },
            {
                //30
                label: '是否关联',
                selected: false,
                default: false,
            },
            {
                label: '冲红原因',
                selected: false,
                default: false,
            },
            {
                label: '红字确认单编号',
                selected: false,
                default: false,
            },
            {
                label: '原蓝票号码',
                selected: false,
                default: false,
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
            },
            {
                label: '本地PDF状态',
                selected: false,
                default: false,
            },
            {
                label: '手机号码',
                selected: false,
                default: false,
                name: 'custMobile',
            },
            {
                label: '回调状态',
                selected: false,
                default: false,
                name: 'callBackStatus',
            },
            {
                label: '税局附件下载状态',
                selected: false,
                default: false,
                name: 'isDownload',
            },
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
            },
            {
                label: '主管税局所在省（市）',
                selected: true,
                default: false,
                name: 'province',
            },
            {
                label: '销方名称',
                selected: true,
                default: true,
                name: 'saleName',
                sort: true,
            },
            {
                //5
                label: '销方信用代码',
                selected: true,
                default: true,
                name: 'saleCreditCode',
                sort: true,
            },
        ],
    },
    3: {
        version: 1.8,
        queryForm: [
            {
                // 0
                label: '开票日期',
                selected: true,
                default: true,
                name: 'invoiceDate',
                type: 'date',
            },
            {
                label: '购方名称',
                selected: true,
                default: true,
                name: 'custName',
            },
            {
                label: '购方信用代码',
                selected: true,
                default: true,
                name: 'custCreditCode',
            },
            {
                label: '发票性质',
                selected: true,
                default: true,
                name: 'isRed',
                dict: 'is_red_all',
                type: 'dict',
            },
            {
                label: '下载标志',
                selected: true,
                default: true,
                name: 'isDownload',
                dict: 'is_download',
                type: 'dict',
            },
            {
                //5
                label: '开票人',
                selected: false,
                default: false,
                name: 'openPeople',
            },
            {
                label: '发票状态',
                selected: false,
                default: false,
                name: 'invoiceStatus',
                dict: 'invoice_status',
                type: 'dict',
            },
            {
                label: '单据编号',
                selected: true,
                default: true,
                name: 'billCode',
                type:'businessBase',
            },
            {
                label: '交付状态',
                selected: true,
                default: true,
                name: 'sendStatus',
                dict: 'send_status',
                type: 'dict',
            },
            {
                label: '全电发票号码',
                selected: false,
                default: false,
                name: 'electricInvoiceNum',
            },
            {
                //10
                label: '数据来源',
                selected: false,
                default: false,
                name: 'invoiceSource',
                dict: 'invoice_source',
                type: 'dict',
            },
            {
                label: '成品油',
                selected: false,
                default: false,
                name: 'invSubType',
                dict: 'yes_no_flag',
                type: 'dict',
            },
            {
                label: '业务单据号',
                selected: false,
                default: false,
                name: 'businessCode',
                type:'businessBase',
            },
            {
                label: '合同号',
                selected: false,
                default: false,
                name: 'contractCode',
                type:'businessBase',
            },
            {
                label: '项目名称',
                selected: false,
                default: false,
                name: 'projectName',
                type:'businessBase',
            },
            {
                //15
                label: '申请人',
                selected: false,
                default: false,
                name: 'applicant',
            },
            {
                label: '扩展1',
                selected: false,
                default: false,
                name: 'extendInfo1',
                type:'businessBase',
            },
            {
                label: '扩展2',
                selected: false,
                default: false,
                name: 'extendInfo2',
                type:'businessBase',
            },
            {
                label: '扩展3',
                selected: false,
                default: false,
                name: 'extendInfo3',
                type:'businessBase',
            },
            {
                label: '冲红原因',
                selected: false,
                default: false,
                name: 'redReason',
                dict: 'red_confirm_red_reason',
                type: 'dict',
            },
            {
                //20
                label: '红字确认单编号',
                selected: false,
                default: false,
                name: 'redInformNo',
            },
            {
                label: '原蓝票号码',
                selected: false,
                default: false,
                name: 'blueElectricInvoiceNum',
            },
            {
                //22
                label: '发票种类',
                selected: false,
                default: false,
                name: 'invType',
                dict: 'inv_type',
                type: 'dict',
            },
            {
                label: '是否还原',
                selected: false,
                default: false,
                name: 'restoreStatus',
                dict: 'yes_no_flag',
                type: 'dict',
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
                name: 'specificElements',
                dict: 'specific_element',
                type: 'dict',
            },
            {
                label: '本地PDF状态',
                selected: false,
                default: false,
                name: 'localPdfStatus',
                dict: 'local_pdf_status',
                type: 'dict',
            },
            {
                label: '手机号码',
                selected: false,
                default: false,
                name: 'custMobile',
            },
            {
                label: '回调状态',
                selected: false,
                default: false,
                name: 'callBackStatus',
                dict: 'call_back_status',
                type: 'dict',
            },
            {
                label: '事业部',
                selected: false,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: false,
                default: false,
                name: 'regionName',
                type: 'regionNo',
            },
            {
                label: '管理城市',
                selected: false,
                default: false,
                name: 'cityName',
                type: 'managerCityNo',
            },
            {
                label: '主管税局省(市)',
                selected: false,
                default: false,
                name: 'province',
                type: 'taxBureauId',
            },
            {
                label: '机构名称',
                selected: false,
                default: false,
                name: 'selectedOrgs',
                type: 'selectedOrgs',
            },
        ],
        table: [
            {
                //0
                label: '单据编号',
                selected: true,
                default: true,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
            },
            {
                label: '全电发票号码',
                selected: true,
                default: true,
            },
            {
                label: '发票性质',
                selected: true,
                default: true,
            },
            {
                label: '购方名称',
                selected: true,
                default: true,
            },
            {
                //5
                label: '购方信用代码',
                selected: true,
                default: true,
            },
            {
                label: '购方地址',
                selected: false,
                default: false,
            },
            {
                label: '购方电话',
                selected: false,
                default: false,
            },
            {
                label: '购方开户行',
                selected: false,
                default: false,
            },
            {
                label: '购方银行账号',
                selected: false,
                default: false,
            },
            {
                //10
                label: '合计金额',
                selected: true,
                default: true,
            },
            {
                label: '合计税额',
                selected: true,
                default: true,
            },
            {
                label: '价税合计',
                selected: false,
                default: false,
            },
            {
                label: '含税折扣金额',
                selected: false,
                default: false,
            },
            {
                label: '备注',
                selected: false,
                default: false,
            },
            {
                //15
                label: '下载标志',
                selected: true,
                default: true,
            },
            {
                label: '发票状态',
                selected: true,
                default: true,
            },
            {
                label: '开票人',
                selected: false,
                default: false,
            },
            {
                label: '开票日期',
                selected: false,
                default: false,
            },
            {
                label: '数据来源',
                selected: false,
                default: false,
            },
            {
                //20
                label: '关联销售单',
                selected: false,
                default: false,
            },
            {
                label: '主商品名称',
                selected: false,
                default: false,
            },
            {
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '邮箱',
                selected: false,
                default: false,
            },
            {
                label: '交付状态',
                selected: false,
                default: false,
            },
            {
                //25
                label: '打印标识',
                selected: false,
                default: false,
            },
            {
                label: '发票ID',
                selected: false,
                default: false,
            },
            {
                label: '成品油',
                selected: false,
                default: false,
            },
            {
                label: '业务单据号',
                selected: false,
                default: false,
            },
            {
                //29
                label: '是否还原',
                selected: false,
                default: false,
            },
            {
                //30
                label: '是否关联',
                selected: false,
                default: false,
            },
            {
                label: '冲红原因',
                selected: false,
                default: false,
            },
            {
                label: '红字确认单编号',
                selected: false,
                default: false,
            },
            {
                label: '原蓝票号码',
                selected: false,
                default: false,
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
            },
            {
                label: '本地PDF状态',
                selected: false,
                default: false,
            },
            {
                label: '手机号码',
                selected: false,
                default: false,
                name: 'custMobile',
            },
            {
                label: '回调状态',
                selected: false,
                default: false,
                name: 'callBackStatus',
            },
            {
                label: '税局附件下载状态',
                selected: false,
                default: false,
                name: 'isDownload',
            },
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
            },
            {
                label: '主管税局所在省（市）',
                selected: true,
                default: false,
                name: 'province',
            },
            {
                label: '销方名称',
                selected: true,
                default: true,
                name: 'saleName',
                sort: true,
            },
            {
                //5
                label: '销方信用代码',
                selected: true,
                default: true,
                name: 'saleCreditCode',
                sort: true,
            },
        ],
    },
}
export default fullEleFieldConfig



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/openedFullEleInvoice/fieldConfig.js